export default __webpack_public_path__ + "static/media/info-filled.1f8948a5.svg";